import React, { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { People as PeopleIcon, LocalShipping as TransportationIcon, ReportProblem as ReportProblemIcon } from '@mui/icons-material';
import NewVisit from './NewVisit';
import Transportation from './Transportation';
import StandaloneUiForm from './StandaloneUiForm';

const entryButtonSx = {
  backgroundColor: '#2D4B73',
  color: '#ffffff',
  py: 1.5,
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 4px 14px 0 rgba(45, 75, 115, 0.4)',
  width: '100%',
  maxWidth: 340,
  '&:hover': { backgroundColor: '#1E3452' },
} as const;

const NewEntry: React.FC = () => {
  const [visitEntryOpen, setVisitEntryOpen] = useState(false);
  const [transportEntryOpen, setTransportEntryOpen] = useState(false);
  const [uiEntryOpen, setUiEntryOpen] = useState(false);
  const [visitSession, setVisitSession] = useState(0);
  const [transportSession, setTransportSession] = useState(0);

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 4,
        backgroundColor: '#ffffff',
        minHeight: 'calc(100vh - 64px)',
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
          <img src="/logo_black.png" alt="EasyIP Logo" style={{ height: '120px' }} />
        </Box>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, textAlign: 'center', maxWidth: 360 }}>
          Start a new visit, record transportation, or report an unusual incident.
        </Typography>
        <Stack
          direction="column"
          spacing={2.5}
          alignItems="center"
          sx={{ width: '100%', px: 2 }}
        >
          <Button
            variant="contained"
            startIcon={<PeopleIcon />}
            onClick={() => {
              setVisitSession(s => s + 1);
              setVisitEntryOpen(true);
            }}
            sx={entryButtonSx}
          >
            New Visit
          </Button>
          <Button
            variant="contained"
            startIcon={<TransportationIcon />}
            onClick={() => {
              setTransportSession(s => s + 1);
              setTransportEntryOpen(true);
            }}
            sx={entryButtonSx}
          >
            New Transportation
          </Button>
          <Button
            variant="contained"
            startIcon={<ReportProblemIcon />}
            onClick={() => setUiEntryOpen(true)}
            sx={entryButtonSx}
          >
            Record Unusual Incident
          </Button>
        </Stack>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="body2" sx={{ color: '#666666', textAlign: 'center', fontSize: '0.875rem' }}>
          Copyright © 2025-2026 DSP Care Solutions LLC, All Rights Reserved
        </Typography>
        <Typography variant="body2" sx={{ color: '#666666', textAlign: 'center', fontSize: '0.875rem', mt: 0.5 }}>
          EasyIP is a trademark of DSP Care Solutions LLC
        </Typography>
      </Box>

      {visitEntryOpen && (
        <NewVisit
          key={visitSession}
          entryVariant="dialogOnly"
          onEntryClose={() => setVisitEntryOpen(false)}
        />
      )}
      {transportEntryOpen && (
        <Transportation
          key={transportSession}
          entryVariant="addDialogOnly"
          onAddEntryClose={() => setTransportEntryOpen(false)}
        />
      )}
      <StandaloneUiForm open={uiEntryOpen} onClose={() => setUiEntryOpen(false)} />
    </Box>
  );
};

export default NewEntry;
